import { ArrowUpRight } from 'lucide-react';
import SectionHeading from './SectionHeading';
import { useInView } from '../hooks/useInView';
import { projects } from '../data/resume';

export default function Projects() {
  const [ref, isVisible] = useInView();

  return (
    <section id="projects" className="section" ref={ref}>
      <div className={`reveal ${isVisible ? 'reveal--visible' : ''}`}>
        <SectionHeading number="02" title="Selected Work" />

        <div className="projects-grid">
          {projects.map((project) => (
            <article key={project.name} className="project-card">
              <div className="project-card-top">
                <div>
                  <h3 className="project-name">{project.name}</h3>
                  <p className="project-tagline">{project.tagline}</p>
                </div>
                <span className="project-status">{project.status}</span>
              </div>

              <p className="project-description">{project.description}</p>

              <ul className="project-highlights">
                {project.highlights.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <div className="project-footer">
                <div className="tag-list">
                  {project.stack.map((tech) => (
                    <span key={tech} className="tag tag--muted">{tech}</span>
                  ))}
                </div>
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                >
                  heardit.co
                  <ArrowUpRight size={15} strokeWidth={2} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
